import { render, staticRenderFns } from "./vs-form-upload.vue?vue&type=template&id=5e37a156&scoped=true"
import script from "./vs-form-upload.vue?vue&type=script&lang=js"
export * from "./vs-form-upload.vue?vue&type=script&lang=js"
import style0 from "./vs-form-upload.vue?vue&type=style&index=0&id=5e37a156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e37a156",
  null
  
)

export default component.exports